<template>
  <head>
    <title>{{ $t("Plans") }}</title>
  </head>
  <div class="plans-view">
    <SideBar>
      <div class="container bg-light h-100 overflow-scroll">
        <div class="d-flex justify-content-center align-items-center mt-5 mb-3">
          <div class="w-100 d-flex justify-content-start align-items-center">
            <h3>{{ $t("Plans") }} ({{ data.length }})</h3>
          </div>
          <div class="w-100 d-flex justify-content-end align-items-center">
            <button
              type="button"
              class="add-btn"
              @click="$router.push('/admin-add-plans')"
            >
              {{ $t("dashboard.AddPlans") }}
            </button>
          </div>
        </div>
        <div class="search-bar w-100 my-4">
          <input
            type="text"
            class="my-inp w-50"
            style="border: 1px solid black"
            :placeholder="$t('dashboard.SearchPlans')"
            v-model="search_for"
            v-on:input="SearchByName()"
          />
        </div>
        <div class="table-responsive">
          <table class="table table-striped table-hover">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">{{ $t("dashboard.bedroomsAR") }}</th>
                <th scope="col">{{ $t("dashboard.bedroomsEN") }}</th>
                <th scope="col">{{ $t("dashboard.spaceAR") }}</th>
                <th scope="col">{{ $t("dashboard.spaceEN") }}</th>
                <th scope="col">{{ $t("dashboard.img") }}</th>
                <th scope="col">{{ $t("dashboard.edit") }}</th>
                <th scope="col">{{ $t("dashboard.delete") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in shown_data" :key="index">
                <th scope="row">{{ item.id }}</th>
                <td>{{ item.bedrooms_ar }}</td>
                <td>{{ item.bedrooms_en }}</td>
                <td>{{ item.space_ar }}</td>
                <td>{{ item.space_en }}</td>
                <td>
                  <img
                    :src="$store.state.server_images + item.image"
                    alt=""
                    style="height: 100px; width: fit-content"
                  />
                </td>
                <td>
                  <button
                    type="button"
                    class="btn btn-outline-success"
                    @click="$router.push('/admin-add-plans?id=' + item.id)"
                  >
                    {{ $t("dashboard.edit") }}
                  </button>
                </td>
                <td>
                  <button
                    type="button"
                    class="btn btn-outline-danger"
                    @click="DeletePlan(item.id)"
                  >
                    {{ $t("dashboard.delete") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </SideBar>
  </div>
</template>

<script>
import SideBar from "@/components/AdminDashboard/SideBar.vue";
import store from "@/store";
import axios from "axios";
export default {
  name: "plans-view",
  data() {
    return {
      data: [],
      shown_data: [],
      search_for: "",
    };
  },
  components: {
    SideBar,
  },
  methods: {
    getData() {
      axios
        .get(store.state.server + "get-all-plans")
        .then((response) => {
          this.data = response.data;
          this.SearchByName();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    SearchByName() {
      this.shown_data =
        this.search_for === ""
          ? this.data
          : this.data.filter(
              (item) =>
                item.bedrooms_ar.includes(this.search_for) ||
                item.space_ar.includes(this.search_for) ||
                item.bedrooms_en
                  .toLowerCase()
                  .includes(this.search_for.toLowerCase()) ||
                item.space_en
                  .toLowerCase()
                  .includes(this.search_for.toLowerCase())
            );
    },
    DeletePlan(id) {
      let conf = window.confirm("هل تريد الحذف؟");
      if (conf) {
        axios
          .get(store.state.server + "delete-plan/" + id)
          .then((response) => {
            if (response.status == 200) {
              location.reload();
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
